import Vue from 'vue'

const state = {}

const actions = {
  SEND_PRE_CHECKOUT_DATA: ({commit}, emailData) => {
    const url = 'send-pre-checkout-email'
    Vue.http.post(url, emailData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          console.log(response)
        }
      })
  }
}

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/email.js